import {defineStore} from "pinia";

interface State {
  _ready: boolean;
}

export const useDefaultStore = defineStore('default-store', {
  state: (): State => ({
    _ready: false,
  }),

  getters: {
    ready: state => {
      return state._ready;
    },
  },

  actions: {
    async initialize(backendUrl: string) {
      if (!this.$state._ready) {
        this.$state._ready = true;
        console.log('initialized store: ' + backendUrl);
      }
    }
  }
})
